import {
  combineReducers,
  configureStore,
  ThunkAction,
  AnyAction,
} from '@reduxjs/toolkit';
import {
  useDispatch,
  TypedUseSelectorHook,
  useSelector,
  useStore,
} from 'react-redux';

import ui from './ui';
import model from './model';

const rootReducer = combineReducers({
  ui,
  model,
});

const reducerProxy = (state: any, action: AnyAction) => {
  if (action.type === 'logout') {
    return rootReducer({} as any, action);
  }

  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: reducerProxy,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware();
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof rootReducer>;
export type Dispatch = typeof store.dispatch;
export type Store = typeof store;
export type Action<R = any> = ThunkAction<
  Promise<R>,
  RootState,
  null,
  AnyAction
>;

export const useAppDispatch = () => useDispatch<Dispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = () => useStore<RootState, AnyAction>();
